








import BottomBar from "./BottomBar.vue";
import NotificationBar from "./NotificationBar.vue";
import AppBar from "./AppBar.vue";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  components: {
    BottomBar,
    NotificationBar,
    AppBar
  }
});
